'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isSingleMode = isSingleMode;
exports.isCheckboxShow = isCheckboxShow;
exports.isMultiUnCheckable = isMultiUnCheckable;
exports.isAllSelectShow = isAllSelectShow;
exports.getRenderValue = getRenderValue;
exports.getShowValue = getShowValue;
exports.getShowData = getShowData;
exports.getServerValue = getServerValue;
exports.calculateInputWidth = calculateInputWidth;
exports.isFindInArray = isFindInArray;

var _reactDom = require('react-dom');

var _lodashCompat = require('lodash-compat');

var _data = require('../util/data');

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

// 是否是单选下拉
function isSingleMode(props) {
  return !props.combobox && !props.multiple;
}

// 是否多选下拉显示选项框
function isCheckboxShow(props) {
  return props.multiple && props.checkbox;
}
// 是否多选下拉不显示选项框
function isMultiUnCheckable(props) {
  return props.multiple && !props.checkbox;
}

// 是否显示全选
function isAllSelectShow(props) {
  return isCheckboxShow(props) && props.allCheck;
}

// 来处理接收的value
function getRenderValue(value) {
  var props = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  var needWarn = arguments[2];
  var model = props.model;
  var multiple = props.multiple;
  var combobox = props.combobox;

  if (multiple) {
    if (Array.isArray(value) && value.length > 0) {
      value = (0, _data.buildMultiSelectData)({ model: model }, value, needWarn);
    } else {
      return [];
    }
  } else if (!combobox) {
    if ((0, _data.isEmptyString)(value)) {
      return null;
    }
    value = (0, _data.buildSelectData)({ model: model }, value, needWarn);
  }
  return value;
}

// 来自控件内部的数据
function getShowValue(value) {
  if ((0, _data.isEmptyString)(value)) {
    return {
      label: '',
      value: ''
    };
  }
  // 智能提示模式
  if (typeof value === 'string') {
    return {
      label: value,
      value: value
    };
  }
  return value;
}

// 来处理从后端获取到的可选项
function getShowData(data) {
  var props = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  var value = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];

  if (Array.isArray(data) && data.length > 0) {
    var _ret = function () {
      var model = props.model;
      var multiple = props.multiple;
      var checkbox = props.checkbox;

      var item = [];
      (data || []).forEach(function (v) {
        // 对于多选来说  如果不显示checkbox, 则筛掉已选择的条目
        if (value && multiple && !checkbox && value.find(function (opt) {
          return opt.value === (v[model.idField] || v);
        })) {
          return;
        } else if (typeof v === 'string') {
          item.push({
            label: v,
            value: v
          });
        } else {
          item.push(_extends({}, v, {
            value: v[model.idField],
            label: model.showTpl ? _util2.default.template(model.showTpl, v) : v[model.showField]
          }));
        }
      });
      return {
        v: item
      };
    }();

    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
  }
  return [];
}

/**
 * 获取要传递出去的value
 * @param model  select 的模板
 * @param showData  当前的可选项
 * @param value  当前选中的值
 * @returns {*}
 */
function getServerValue(model, showData, value) {
  if (Array.isArray(value)) {
    // 如果是多选
    return (0, _data.buildMultiSelectData)({ model: model }, value);
  } else if (_.isObject(value)) {
    // 如果是单选
    return (0, _data.buildSelectData)({ model: model }, value);
  } else if (typeof value === "string") {
    return value;
  }
}

/**
 * 计算输入框的宽度, 只对 `multiple` 可编辑的时候有效
 * @param container 组件
 * @return {Boolean} 是否高度有变化
 */
function calculateInputWidth(container, input) {
  var $container = (0, _reactDom.findDOMNode)(container);
  if (!$container) {
    return;
  }
  var $input = input ? (0, _reactDom.findDOMNode)(input) : $container.querySelector('input');
  if (!$input) {
    return;
  }
  var width = $container.getBoundingClientRect().width - 25; // 减去container 的 padding 及 border 及可能出现的滚动条
  var $selectedList = $container.querySelector('ul');
  if ($selectedList) {
    (function () {
      var sum = 0,
          $list = Array.from($selectedList.querySelectorAll('li'));
      // 计算每个 li 的宽度
      $list.forEach(function ($li, index) {
        // 加6是由于 li 有margin
        var _liWidth = $li.getBoundingClientRect().width + 4; // 4: li 的margin
        var _plus = _liWidth + sum;
        if (index === $list.length - 1) {
          // 如果是最后一个元素, 判断是那种情况
          if (_plus > width) {
            // 需要这个元素去换行
            if (_liWidth + 50 > width) {
              // 需要 input 去换行(50: input 的最小宽度)
              sum = 0;
            } else {
              sum = _liWidth;
            }
          } else if (_plus + 50 > width) {
            // 需要 input 去换行(50: input 的最小宽度)
            sum = 0;
          } else {
            // 谁都不用换行
            sum = _plus;
          }
        } else {
          if (_plus > width) {
            // 需要这个元素去换行
            sum = _liWidth;
          } else {
            // 谁都不用换行
            sum = _plus;
          }
        }
      });
      // 4: input 的 margin
      $input.style.width = width - sum - 4 + 'px';
    })();
  } else {
    $input.style.width = width - 4 + 'px';
  }
}

/**
 * 是否在嵌套的数组里找到某个元数据
 * @param array 嵌套的数组 [1,'2',{'a': '1', 'b': ['2']}]
 * @param res
 * @returns {boolean|*}
 */
function isFindInArray(array, res) {
  return !(0, _lodashCompat.isEmpty)(res) && Array.isArray(array) && array.length > 0 && array.some(function (prop) {
    if (['string', 'number'].some(function (v) {
      return v === (typeof prop === 'undefined' ? 'undefined' : _typeof(prop));
    })) {
      return prop === res.code;
    } else if ((0, _lodashCompat.isObject)(prop) && !(0, _lodashCompat.isEmpty)(prop)) {
      return Object.keys(prop).some(function (p) {
        if (['string', 'number'].some(function (v) {
          return v === _typeof(prop[p]);
        })) {
          return prop[p] === res[p];
        } else if (Array.isArray(prop[p]) && prop[p].length > 0) {
          return prop[p].some(function (v) {
            return v === res[p];
          });
        }
      });
    }
  });
}